import { stylesFixed as stylesFixedUpload } from "../../../../components/single-registry/upload/UploadFile/UploadFile.styles";

export const stylesFixed = {
  ...stylesFixedUpload,
  boxHeader: {
    textAlign: "left",
    marginTop: "40px",
    marginBottom: "40px",
  },
  title: {
    fontWeight: 400,
    color: "#1E293B",
    fontFamily: "'Ubuntu', Arial, sans-serif",
    fontSize: "18px",
    lineHeight: "25px",
  },
  subtitle: {
    fontWeight: 500,
    color: "#475569",
    fontFamily: "'Ubuntu', Arial, sans-serif",
    fontSize: "14px",
  },
};
